<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="650px"
      :persistent="true"
    >
      <v-card
        class="pa-5"
        style="border-radius: 7px;"
        elevation="10"
      >
        <v-card-title class="pb-3">
          <v-row>
            <v-col cols="auto">
              <span style="font-weight: bold; font-size: 26px; color: #000000;">{{ title }}</span>
            </v-col>
            <v-col class="text-end pt-0">
              <v-btn
                icon
                @click="cancel"
                color="#000000"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <span style="font-size: 18px; color: #000000;">{{ message }} <a
            :href="link"
            target="_blank"
          >User Profile</a></span>
        </v-card-text>
        <v-card-actions class="pr-2">
          <v-spacer />
          <v-btn
            class="mr-2"
            text
            color="#000000"
            @click="cancel"
          >
            <span style="font-size: 14px;">{{ cancelBtn }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
  
  <script>
  
  export default {
    props: {
    environment: {
      type: String,
      default: '',
    },
  },
    data: () => ({
      title: 'Approval',
      message: 'It appears that you haven\'t yet created your permanent electronic signature. Please create one in your ',
      cancelBtn: 'Close',
      dialog: false,
      link: ''
    }),
    mounted() {
    },
    methods: {
  
      open() {
        const serverPrefix = process.env.VUE_APP_SERVER_PREFIX
        const serverAddress = process.env.VUE_APP_SERVER_ADDRESS
        this.link = `${serverPrefix}${this.environment}.${serverAddress}/workers/my_account`
        this.dialog = true;
      },
  
      cancel() {
        this.dialog = false;
      },
    },
  };
  </script>
  